import type { ItemRenderer } from "./types";

export const renderShelf: ItemRenderer = ({ svg, bboxPx, item }) => {
    const color = "#a64022";
    const isPerf = item?.name?.toLowerCase()?.includes("перф") ?? false;

    const edgeStroke = 0.45;
    const safeRect = {
        x: bboxPx.x + edgeStroke / 2,
        y: bboxPx.y + edgeStroke / 2,
        w: Math.max(0, bboxPx.w - edgeStroke),
        h: Math.max(0, bboxPx.h - edgeStroke),
    };

    svg.rect(safeRect.w, safeRect.h).move(safeRect.x, safeRect.y).fill("#FFFFFF").stroke({ width: edgeStroke, color });

    if (isPerf) {
        const waveStroke = 0.3;
        const leftX = safeRect.x + waveStroke / 2;
        const rightX = safeRect.x + safeRect.w - waveStroke / 2;

        const topSafeY = safeRect.y + waveStroke / 2;
        const bottomSafeY = safeRect.y + safeRect.h - waveStroke / 2;

        const ampMaxByHeight = Math.max(0, (bottomSafeY - topSafeY) / 2);
        const amp = Math.min(ampMaxByHeight, Math.max(0.8, Math.min(1.6, safeRect.h * 0.08)));

        const step = Math.max(2, Math.min(6, safeRect.w / 40));

        const baseY = topSafeY + amp;

        let d = `M ${leftX} ${baseY}`;
        let x = leftX;
        let dir = +1;
        while (x + step <= rightX) {
            const next = x + step;
            d += ` v ${dir * amp} H ${next} V ${baseY}`;
            x = next;
            dir *= -1;
        }
        if (x < rightX) {
            d += ` v ${dir * amp} H ${rightX} V ${baseY}`;
        }

        svg.path(d).fill("none").stroke({ width: waveStroke, color, linecap: "butt", linejoin: "miter" });
        return;
    }

    const topStroke = 0.6;
    const y = safeRect.y + topStroke / 2;
    const x1 = safeRect.x + edgeStroke / 2;
    const x2 = safeRect.x + safeRect.w - edgeStroke / 2;

    svg.line(x1, y, x2, y).stroke({ width: topStroke, color, linecap: "butt" });
};
